<template>
	<div id="register" class="register">
		<div class="page-container" id="register-container">
		    <div class="page-content" id="register-content">
		    		<article class="article" id="step-0" v-show="currentPage === 0 && registrationStatus != true">
		    			<div class="topLoginLink">
		    				<a href="javascript:void(0)" @click="loginArticle">Log in</a>
		    			</div>
		    			<div id="topLogo">
			    			<div class="logo-col">
			    				<img :src="storeLogo">
			    			</div>
		    			</div>
			        <div class="store-name">
			            <h1>{{storeName}}</h1>
			        </div>
		    		</article>
		    	
		    	
			    	<article class="article" id="step-1" v-show="currentPage === 1">
			    		<div class="absTopBg">
			    			<div class="circleModule">
			    				<div class="minCircleModule"></div>
			    			</div>
			    		</div>
			    		<header id="main-menu" class="logo-header">
			    			<div class="logo-col">
			    				<img :src="storeLogo">
			    			</div>
			    		</header>
			    		
			    		<div class="register-modules">
			    			<section class="section">
			    				<form id="loginForm">
				    				<div class="module">
					    				<div class="title">
					    					Create account with your email
					    				</div>
					    				<div class="module-body">
					    					<div class="form-group">
					    						<label class="label">Email</label>
					    						<input class="form-control" value="" id="email" name="email" 
					    							placeholder="Please enter your email here" type="email" required="required" />
					    					</div>
					    					<div class="form-group">
					    						<label class="label">Password</label>
					    						<input class="form-control" value="" id="password" name="password" 
					    							placeholder="Please enter your password" type="password" required="required"  />
										</div>
										<div class="tips"><a href="javascript:;">Forgot your password?</a></div>
										<div class="line"></div>
										<button type="submit" class="login" v-if="type !=='email'"><span>LOG IN</span></button>	
										<button type="submit" class="login" v-if="type=='email'"><span>NEXT</span></button>
									</div>	
				    				</div>
			    				</form>
						</section>
						<div class="connectwith">
							<span class="words">Connect with</span>
							<span class="facebookLogo" @click="facebookSignup"><i class="ti-facebook"></i></span>
							<span class="googleLogo" @click="googleSignup"><i class="ti-google"></i></span>
						</div>
			    		</div>
			    	</article>	
			    	
				<article class="article" id="step-2" v-show="currentPage === 2">
			    		<div class="absTopBg">
			    			<div class="triangleShape"></div>
			    		</div>
			    		<div class="absBottomBg">
			    			<div class="circleModule">
			    				<div class="minCircleModule"></div>
			    			</div>
			    		</div>			    		
			    		<div class="bannerTipsWordsCol">
			    			<h2>Looks good?</h2>
			    			<p>Make sure your information is correct before continuing.</p>
			    		</div>

			    		
			    		<div class="register-modules">
			    			<div class="triangleShapeBg">
			    				<img src="../assets/images/form_bg.png">
				    			<section class="hasTriangleSection section">
				    				<form id="thirdPartyLoginForm">
					    				<div class="module">
						    				<div class="module-body">
						    					<div class="form-group">
						    						<label class="label">First Name</label>
						    						<input class="form-control" value="" id="firstName" name="first_name" v-model="thirdPartyLoginForm.firstName"
						    							placeholder="Please enter your first name here" type="text" required="required" />
						    						<i class="ti-marker-alt"></i>
						    					</div>
						    					<div class="form-group">
						    						<label class="label">Last Name</label>
						    						<input class="form-control" value="" id="lastName" name="last_name" v-model="thirdPartyLoginForm.lastName"
						    							placeholder="Please enter your Surname" type="text" required="required"  />
						    						<i class="ti-marker-alt"></i>					    							
											</div>
						    					<div class="form-group">
						    						<label class="label"><strong>Birthday</strong></label>
						    						<div id="trigger" class="form-control"></div>
						    						<input class="form-control" value="" id="birthday" name="birthday" v-model="thirdPartyLoginForm.birthday"
						    							placeholder="Please enter your birthday" type="hide" autocomplete="off" />
											</div>
						    					<div class="form-group">
						    						<label class="label">Email</label>
						    						<input class="form-control" value="" id="email" name="email" v-model="thirdPartyLoginForm.email"
						    							placeholder="aa@bb.cc" type="email" required="required"  />
						    						<i class="ti-marker-alt"></i>					    							
											</div>
											
											<div class="line"></div>
											<button type="submit" class="login"><span>SIGN UP</span></button>
										</div>	
					    				</div>
				    				</form>
				    				
							</section>

			    			</div>
			    			<div class="userAgreeCol">
			    				<p>I’d like to receive marketing promotions, special offers, inspirations, and policy updates from {{ storeName }}</p>
			    				<div class="grid">
			    					<div class="statusCol">
			    						<label class="minWhite" for="agreeReceive"><span v-if="sure === true">Yes, sure</span><span v-if="sure !== true">No, thanks</span></label>
								    <input id="agreeReceive" type="checkbox" class="style switch" checked="checked" v-model="sure" />
							    </div>
			    				</div>
			    			</div>

			    		</div>
			    	</article>	
		    		
		    		<div id="topButtonCol" v-if="currentPage > 1">
		    			<a href="javascript:void(0)" id="backBtn" class="backBtn" @click="back"></a>
		    		</div>
		    		<div id="topButtonCol" class="backStartLink" v-if="currentPage === 1 && startPage === 0">
		    			<a href="javascript:void(0)"  id="backBtn" class="backBtn" @click="back"></a>
		    		</div>		    		
		    </div>
		</div>
	    

	</div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import MobileSelect from 'mobile-select';
export default {
  name: 'Register',
  components: {
//	  Loading
  },
  data() {
	  return {
	  	type: '',
		storeLogo:'https://cloudoffice.sparkepos.com/static/image/webLogo_date190621.png',
		storeName:'Spark Demo',	
		currentPage: 0,
		registrationStatus:false,
		fromPage:1,
		startPage:'',
		type:'',
		sure: true,
		paramsValid: true,
		loginForm: {
			email: '',
			password: '',
		},
		thirdPartyLoginForm :{
			firstName: '',
			lastName: '',
			birthday: '',
			email: '',
		},
	  }
  },
  methods: {
	signup(){},
	back(){
		if (this.currentPage === 2){
			if(this.fromPage === 1){
				this.currentPage = 1;
			}
//			else if(this.fromPage === 0){
//				this.currentPage = 0;
//			}
			
		}else if(this.currentPage === 1 && this.startPage === 0){
			this.currentPage = 0;
		}
//		if (this.currentPage === 1){
//			if(this.fromPage === 0){
//				this.currentPage = 0;
//			}
//			if(this.startPage === 0){
//				this.currentPage = 0;
//			}			
//		}		
		
	},
	loginArticle(){
		this.currentPage = 1;
		this.fromPage = 0;
		this.startPage = 0
	},
	facebookSignup(){
		this.currentPage = 2;
		this.fromPage = 1;
//		this.startPage = startPage;
		$("#thirdPartyLoginForm").valid();
        let form = $('#thirdPartyLoginForm');
		if (!form.valid()) {
			this.paramsValid = false;
		} else {
			this.paramsValid = true;
		}
	},
	googleSignup(){
		//这里和fackbook的登录共用一套页面，但接口不同
		this.currentPage = 2;
		this.fromPage = 1;
//		this.startPage = startPage;
		$("#thirdPartyLoginForm").valid();
        let form = $('#thirdPartyLoginForm');
		if (!form.valid()) {
			this.paramsValid = false;
		} else {
			this.paramsValid = true;
		}
	},	
	
  },
   mounted() {
	$("#thirdPartyLoginForm").validate({
		rules: {
			first_name: {
				required: true,
				minlength: 2
			},
			last_name: {
				required: true,
				minlength: 2
			},
			email: "required",

		},
		messages: {
			first_name: {
				required: "The first name cannot be empty",
				minlength: "Your first name must consist of at least 2 characters"
			},
			last_name: {
				required: "The last name cannot be empty",
				minlength: "Your last name must consist of at least 2 characters"
			},
			email: {
				required: "Email cannot be empty",
				minlength:"Please enter a valid email address"
			},
		},
        errorElement: 'div',
        errorClass: 'form-control-feedback',
		errorPlacement: function ( error, element ) {
			// Add the `help-block` class to the error element
			error.addClass( "form-control-feedback" );

			if ( element.prop( "type" ) === "checkbox" ) {
				error.appendTo( element.parents( ".form-group" ) );
			}else if ( element.prop( "type" ) === "file" ) {
				error.addClass("error-words").insertAfter( element.parents( ".error-col" ).find(".error-words") );
			} else {
				error.appendTo( element.parent( ".form-group" ) );
			}
		},
		highlight: function ( element, errorClass, validClass ) {
			$( element ).parents( ".form-group" ).addClass( "has-danger" ).removeClass( "has-success" );
		},
		unhighlight: function (element, errorClass, validClass) {
			$( element ).parents( ".form-group" ).addClass( "has-success" ).removeClass( "has-danger" );
		}
	});
	
	
	$("#loginForm").validate({
		rules: {
			email: "required",
			password:  {
				required: true,
				minlength: 2
			},
		},
		messages: {
			password: {
				required: "The password cannot be empty",
				minlength: "Your password is wrong"
			},
			email: {
				required: "Email cannot be empty",
				minlength:"Please enter a valid email address"
			},
		},
        errorElement: 'div',
        errorClass: 'form-control-feedback',
		errorPlacement: function ( error, element ) {
			// Add the `help-block` class to the error element
			error.addClass( "form-control-feedback" );

			if ( element.prop( "type" ) === "checkbox" ) {
				error.appendTo( element.parents( ".form-group" ) );
			}else if ( element.prop( "type" ) === "file" ) {
				error.addClass("error-words").insertAfter( element.parents( ".error-col" ).find(".error-words") );
			} else {
				error.appendTo( element.parent( ".form-group" ) );
			}
		},
		highlight: function ( element, errorClass, validClass ) {
			$( element ).parents( ".form-group" ).addClass( "has-danger" ).removeClass( "has-success" );
		},
		unhighlight: function (element, errorClass, validClass) {
			$( element ).parents( ".form-group" ).addClass( "has-success" ).removeClass( "has-danger" );
		}
	});

   	var dataDay1 = [{id:'1',value:'01'}, {id:'2',value:'02'}, {id:'3',value:'03'}, {id:'4',value:'04'}, {id:'5',value:'05'}, {id:'6',value:'06'}, {id:'7',value:'07'}, {id:'8',value:'08'}, {id:'9',value:'09'}, {id:'10',value:'10'}, {id:'11',value:'11'}, {id:'12',value:'12'}, {id:'13',value:'13'}, {id:'14',value:'14'}, {id:'15',value:'15'}, {id:'16',value:'16'}, {id:'17',value:'17'}, {id:'18',value:'18'}, {id:'19',value:'19'}, {id:'20',value:'20'}, {id:'21',value:'21'}, {id:'22',value:'22'}, {id:'23',value:'23'}, {id:'24',value:'24'}, {id:'25',value:'25'}, {id:'26',value:'26'}, {id:'27',value:'27'}, {id:'28',value:'28'}, {id:'29',value:'29'}, {id:'30',value:'30'}, {id:'31',value:'31'}];
   	var dataDay2 = [{id:'1',value:'01'}, {id:'2',value:'02'}, {id:'3',value:'03'}, {id:'4',value:'04'}, {id:'5',value:'05'}, {id:'6',value:'06'}, {id:'7',value:'07'}, {id:'8',value:'08'}, {id:'9',value:'09'}, {id:'10',value:'10'}, {id:'11',value:'11'}, {id:'12',value:'12'}, {id:'13',value:'13'}, {id:'14',value:'14'}, {id:'15',value:'15'}, {id:'16',value:'16'}, {id:'17',value:'17'}, {id:'18',value:'18'}, {id:'19',value:'19'}, {id:'20',value:'20'}, {id:'21',value:'21'}, {id:'22',value:'22'}, {id:'23',value:'23'}, {id:'24',value:'24'}, {id:'25',value:'25'}, {id:'26',value:'26'}, {id:'27',value:'27'}, {id:'28',value:'28'}, {id:'29',value:'29'}, {id:'30',value:'30'}];
   	var dataDay3 = [{id:'1',value:'01'}, {id:'2',value:'02'}, {id:'3',value:'03'}, {id:'4',value:'04'}, {id:'5',value:'05'}, {id:'6',value:'06'}, {id:'7',value:'07'}, {id:'8',value:'08'}, {id:'9',value:'09'}, {id:'10',value:'10'}, {id:'11',value:'11'}, {id:'12',value:'12'}, {id:'13',value:'13'}, {id:'14',value:'14'}, {id:'15',value:'15'}, {id:'16',value:'16'}, {id:'17',value:'17'}, {id:'18',value:'18'}, {id:'19',value:'19'}, {id:'20',value:'20'}, {id:'21',value:'21'}, {id:'22',value:'22'}, {id:'23',value:'23'}, {id:'24',value:'24'}, {id:'25',value:'25'}, {id:'26',value:'26'}, {id:'27',value:'27'}, {id:'28',value:'28'}, {id:'29',value:'29'}];
   	var dataDate = [{id: '1',value: 'January',childs:dataDay1},
					{id: '2',value: 'February',childs:dataDay3},
					{id: '3',value: 'March',childs:dataDay1},
					{id: '4',value: 'April',childs:dataDay2},
					{id: '5',value: 'May',childs:dataDay1},
					{id: '6',value: 'June',childs:dataDay2},
					{id: '7',value: 'July',childs:dataDay1},
					{id: '8',value: 'August',childs:dataDay1},
					{id: '9',value: 'September',childs:dataDay2},
					{id: '10',value: 'October',childs:dataDay1},
					{id: '11',value: 'November',childs:dataDay2},
					{id: '12',value: 'December',childs:dataDay1}];
    var mobileSelect = new MobileSelect({
        trigger: "#trigger",
        ensureBtnText:"OK",
        cancelBtnText:"Cancel",
        title: "Birthday",
        wheels: [
                {data:dataDate}
        ],
        position:[0,0],
        callback:function(indexArr, data){
            $('#trigger').html(data[1].value + ' ' + data[0].value)
        }
    });  
     
   
   }
 
}
</script>

<style scoped>
@supports (-webkit-appearance:none) or (-moz-appearance:none){input.style[type=checkbox],input.style[type=radio]{--active:#275EFE;--active-inner:#fff;--focus:2px rgba(39, 94, 254, .3);--border:#BBC1E1;--border-hover:#275EFE;--background:#fff;--disabled:#F6F8FF;--disabled-inner:#E1E6F9;-webkit-appearance:none;-moz-appearance:none;height:21px;outline:0;display:inline-block;vertical-align:top;position:relative;margin:0;cursor:pointer;border:1px solid var(--bc,var(--border));background:var(--b,var(--background));transition:background .3s,border-color .3s,box-shadow .2s}
input.style[type=checkbox]:after,input.style[type=radio]:after{content:'';display:block;left:0;top:0;position:absolute;transition:transform var(--d-t,.3s) var(--d-t-e,ease),opacity var(--d-o,.2s)}
input.style[type=checkbox]:checked,input.style[type=radio]:checked{--b:var(--active);--bc:var(--active);--d-o:.3s;--d-t:.6s;--d-t-e:cubic-bezier(.2, .85, .32, 1.2)}
input.style[type=checkbox]:disabled,input.style[type=radio]:disabled{--b:var(--disabled);cursor:not-allowed;opacity:.9}
input.style[type=checkbox]:disabled:checked,input.style[type=radio]:disabled:checked{--b:var(--disabled-inner);--bc:var(--border)}
input.style[type=checkbox]:disabled+label,input.style[type=radio]:disabled+label{cursor:not-allowed}
input.style[type=checkbox]:hover:not(:checked):not(:disabled),input.style[type=radio]:hover:not(:checked):not(:disabled){--bc:var(--border-hover)}
input.style[type=checkbox]:focus,input.style[type=radio]:focus{box-shadow:0 0 0 var(--focus)}
input.style[type=checkbox]:not(.switch),input.style[type=radio]:not(.switch){width:21px}
input.style[type=checkbox]:not(.switch):after,input.style[type=radio]:not(.switch):after{opacity:var(--o,0)}
input.style[type=checkbox]:not(.switch):checked,input.style[type=radio]:not(.switch):checked{--o:1}
input.style[type=checkbox]+label,input.style[type=radio]+label{font-size:14px;line-height:21px;display:inline-block;vertical-align:top;cursor:pointer;margin-left:4px}
input.style[type=checkbox]:not(.switch){border-radius:7px}
input.style[type=checkbox]:not(.switch):after{width:5px;height:9px;border:2px solid var(--active-inner);border-top:0;border-left:0;left:7px;top:4px;transform:rotate(var(--r,20deg))}
input.style[type=checkbox]:not(.switch):checked{--r:43deg}
input.style[type=checkbox].switch{width:38px;border-radius:11px}
input.style[type=checkbox].switch:after{left:2px;top:2px;border-radius:50%;width:15px;height:15px;background:var(--ab,var(--border));transform:translateX(var(--x,0))}
input.style[type=checkbox].switch:checked{--ab:var(--active-inner);--x:17px}
input.style[type=checkbox].switch:disabled:not(:checked):after{opacity:.6}
input.style[type=radio]{border-radius:50%}
input.style[type=radio]:after{width:19px;height:19px;border-radius:50%;background:var(--active-inner);opacity:0;transform:scale(var(--s,.7))}
input.style[type=radio]:checked{--s:.5}
}
input.style[type=checkbox].switch:checked:after{ background: rgba(80, 227, 194, 1);}
input.style[type=checkbox].switch:checked{ background: #fff;}
input.style[type=checkbox].switch{ border-color:#fff}
input.style[type=checkbox].switch:checked:before{font-family:themify;content:"\e64c";speak:none;font-style:normal;font-weight:700;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale; margin-left: 3px; color: rgba(80, 227, 194, 1);-webkit-transform: translateX(var(--x,0));transform: translateX(var(--x,0));}

</style>


// WEBPACK FOOTER //
// src/page/Register.vue